import React from 'react';
import { DashboardAccountMenu } from '../components/dashboard';

export default function OperatorDashboardHeader({
  accountMenuOpen,
  customerName,
  logout,
  navigate,
  onAccountMenuOpenChange,
  session,
}) {
  return (
    <DashboardAccountMenu
      className="operator-dashboard-account-menu"
      customerName={customerName}
      label="User"
      logout={logout}
      navigate={navigate}
      onOpenChange={onAccountMenuOpenChange}
      open={accountMenuOpen}
      overlayClassName="operator-dashboard-account-dropdown"
      session={session}
    />
  );
}
